export enum OauthStates {
  EMPTY = 'empty',
  LOGINREQUESTED = 'login-requested',
  /** enforce a re-login, probably a stepup (without logout) */
  RELOGINREQUESTED = 'relogin-requested',
  /** when a logout with subsequent login has been triggered */
  REAUTHREQUIRED = 'reauth-required',
  /** directly enforce profile-selection even without having a JWT first */
  PROFILESELECTIONREQUESTED = 'profile-selection-requested',
  /** is set either in init or after auth code flow, must not be pushed explicitly */
  LOGGEDIN = 'logged-in',
  LOGOUTREQUESTED = 'logout-requested',
  LOGOUTREQUESTEDEXTERNAL = 'logout-requested-external',
  /** transitional state, handled differently from LOGGEDOUT, but at the end we're LOGGEDOUT */
  LOGGEDOUTEXTERNAL = 'logged-out-external',
  IDLETIMEDOUT = 'idle-session-timed-out',
  MAXTIMEDOUT = 'max-session-timed-out',
  LOGOUTAFTERIDLESESSIONTIMEOUT = 'logged-out-after-idle-session-timeout',
  LOGOUTAFTERMAXSESSIONTIMEOUT = 'logged-out-after-max-session-timeout',
  /** transitional state, handled differently from LOGOUTREDIRECTED, but at the end we're LOGGEDOUT (or not) */
  LOGOUTREDIRECTEDEXTERNAL = 'logout-redirected-external',
  RESENDTOKEN = 'resend-token',
  RENEWTOKEN = 'renew-token',
  ACCOUNTLINK_REQUESTED = 'account-link-requested',
}

export enum OiamCookie {
  SESSIONID = 'BA-SessionId',
  SESSIONCOOKIE = 'oiamsession',
  BACKENDACCESSCOOKIE = 'BackendAccessTS',
}

/**
 * Internal use only (SessionService session check), no interface for eServices (and so not in oiam-oauth-types)
 */
export interface LogoutEventPayload {
  reason: OauthStates.IDLETIMEDOUT | OauthStates.MAXTIMEDOUT | OauthStates.LOGGEDOUTEXTERNAL;
}

export enum AuthRequestReason {
  LOGINEVENT = 'login-event',
  STEPUP = 'stepup',
  OTHER_STEPUP = 'other_stepup',
  MOTP = 'motp',
  FORCE_PROFILE_SELECT = 'force-profile-select',
  PROFILE_SELECT = 'profile-select',
  BAFOR_CHANGE = 'bafor-change',
  RELOGIN = 'relogin',
  FORCE_BAFOR = 'force-bafor',
  ACTING_TYPE_CHANGE = 'acting-type-change',
  SESSION_CHANGE = 'session-change',
  MISSING_USER = 'missing-user',
  ACCOUNT_LINK = 'account-link',
}
